// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal[data-v-44cdf79d]{max-width:61.25rem}@media (min-width:900px){.modal.lock-aspect-ratio[data-v-44cdf79d]{aspect-ratio:16/9}}.modal-small[data-v-44cdf79d]{max-width:27.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
